interface BillingToggleProps {
  billingInterval: 'month' | 'year'
  setBillingInterval: (interval: 'month' | 'year') => void
}

export const BillingToggle = ({ billingInterval, setBillingInterval }: BillingToggleProps) => {
  return (
    <div className="mb-6 flex justify-center">
      <div className="relative flex overflow-hidden rounded-full border border-gray-200 bg-white shadow-sm">
        <button
          onClick={() => setBillingInterval('year')}
          className={`font-radio-grotesk z-10 rounded-full px-6 py-2 text-base transition-colors focus:outline-none ${billingInterval === 'year' ? 'bg-black text-white' : 'bg-transparent text-black'}`}
          style={{ transition: 'background 0.2s, color 0.2s' }}
        >
          Yearly
        </button>
        <button
          onClick={() => setBillingInterval('month')}
          className={`font-radio-grotesk z-10 rounded-full px-6 py-2 text-base transition-colors focus:outline-none ${billingInterval === 'month' ? 'bg-black text-white' : 'bg-transparent text-black'}`}
          style={{ transition: 'background 0.2s, color 0.2s' }}
        >
          Monthly
        </button>
      </div>
    </div>
  )
}
